<template>
  <div class="brandIdBlock">
    <el-button type="primary" v-if="!batchBrand" @click="useBrandConf" style="margin-bottom: 10px">一键应用品牌配置</el-button>
    <!-- <pre>{{shopList}}</pre> -->
    <div class="brandId-row" v-for="shop in showShopList" :key="shop.id">
      <!-- <el-form ref="brandForm" :model="shop" v-if="shop.state!=1" style="margin-bottom:15px"> -->
      <el-form ref="brandForm" :model="shop" :class="!batchBrand ? 'mt-15':''">
        <el-form-item prop="id" :rules="itemRules(shop)">
          <el-image :src="shop.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
          <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
            <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
          </el-tooltip>
          <span class="shop-title">
            <em v-if="shop.required" class="required">*</em>
            {{ shop.shortTitle || shop.title }}
          </span>
          <el-select
            :value="valueMap[shop.id]"
            value-key="vid"
            name-key="vvalue"
            v-loading="loading[shop.id]"
            :filterable="filterable"
            :remote="remote"
            :remote-method="($event) => remoteMethod($event, shop.id)"
            @change="v => selectChange(v)"
            @focus="() => selectFocus(shop.id)"
          >
            <template v-if="brandOptions[shop.id]">
              <el-option v-for="brandOp in brandOptions[shop.id].renderOptions" :key="brandOp.vid" :label="brandOp.vvalue" :value="brandOp"> </el-option>
            </template>
          </el-select>
          <el-link 
           v-if="!batchBrand  && valueMap && valueMap[shop.id] && valueMap[shop.id].vvalue || ''"
              style="margin-left: 8px" 
              @click="handleSetToShop(shop,valueMap && valueMap[shop.id] && valueMap[shop.id].vvalue)"
              >应用到其他店铺
          </el-link>
          <span v-if="getFail[shop.id]" class="error-text">{{
            getFail[shop.id] === true ? '店铺订购应用已过期，请重新订购以获取店铺品牌' : getFail[shop.id]
          }}</span>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog-select-shop
          v-if="shopDialogVisible"
          :visible.sync="shopDialogVisible"
          :shopData="shopList"
          placeholder="店铺名称"
          @confirm="confirmSelectShop"
      ></el-dialog-select-shop>
  </div>
</template>

<script>
import { getPddCategoryPropertiesNew, getApplyBrandConfig, getPddBrandList } from '@/servers/prod/center/pdd.js';
import { ApplyToOtherShop } from '@/servers/prod/center/fxg.js';

import { cloneDeep } from 'lodash';
import _ from 'lodash';
const PLATFORMID = 'PinShop';
export default {
  name: 'pddBrandIdBlock',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    shopList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    categoryIds: {
      type: Array,
      default() {
        return [];
      },
    },
    filterable: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    source: {
      type: String, //来源于详情还是批量删除页面，批量删除页面不需要默认根据店铺列表获取列表接口 batchDelete
      default() {
        return ''
      },
    },
    batchBrand: {
      type: Boolean,
      default() {
        return false
      }
    },
    baseItemId: [String, Number],
    showShopNum: {
      type: Number | null,
      default() {
        return null
      }
    },
  },
  data() {
    return {
      valueMap: {},
      brandOptions: {},
      loading: {},
      getFail: {},
      shopDialogVisible:false,
      selectShopIds: '',
      applyShopName:'',//发货时效应用的店铺名称
      applyShopObj:[],//发货时效应用的店铺对象

    };
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        if (v && v.length) {
          v.forEach(item => {
            this.$set(this.valueMap, item.shopId, item);
          });
        }
      },
    },
  },
  computed:{
    showShopList(){
      if(typeof this.showShopNum === 'number'){
        return this.shopList.slice(0,this.showShopNum)
      }else{
        return this.shopList
      }
    }
  },
  methods: {
    itemRules(shop) {
      const validShop = (rule, value, callback) => {
        if (!shop.required) {
          return callback();
        }
        const itemValue = this.valueMap[shop.id]
        if (!itemValue) {
          return callback(new Error('该类目下品牌必填，品牌为空不支持商品发布'))
        }
        return callback();
      }
      return [{ required: shop.required, validator: validShop }]
    },
    async method_validate() {
      let validSuccess = false;
      // let getFail = {};
      const brandForm = this.$refs.brandForm;
      const promiseALL = [];
      (brandForm || []).forEach(item => {
        promiseALL.push(new Promise(resolve => {
          item.validate(valid => {
            resolve(valid)
          })
        }));
      })
      return new Promise(resolve => {
        Promise.all(promiseALL).then((results) => {
          validSuccess = results.every(item => {
            return item === true;
          });
          resolve(validSuccess)
        }).catch(() => {
          resolve(false)
        })
      });
    },
    selectFocus(shopId) {
      if (!this.brandOptions[shopId]) {
        this.getPddBrandList(shopId);
      }
    },
    selectBlur(shopId) {
      // this.$nextTick(() => {
      //   if (this.brandOptions[shopId]) {
      //     const options = this.brandOptions[shopId].originOptions;
      //     this.brandOptions[shopId].renderOptions = cloneDeep(options);
      //   }
      // })
    },
    selectChange(v) {
      let newVal = _.cloneDeep(this.value);
      let oindex = newVal.findIndex(({ shopId }) => shopId === v.shopId);
      if (oindex > -1) {
        newVal.splice(oindex, 1, v);
      } else {
        newVal.push(v);
      }
      this.changeVal(newVal);
      // this.$nextTick(() => {
      //   const options = this.brandOptions[v.shopId].originOptions;
      //   this.brandOptions[v.shopId].renderOptions = cloneDeep(options);
      // })
    },
    changeVal(newVal) {
      newVal.forEach(item => {
          const channel = this.shopList.find(shop => shop.id == item.shopId)?.channel
          item.channel = channel
      })
      this.$emit('change', newVal)
    },
    remoteMethod(queryText, shopId) {
      if (queryText === '') {
        const options = this.brandOptions[shopId].originOptions;
        this.brandOptions[shopId].renderOptions = cloneDeep(options);
        return false;
      }
      if (!this.brandOptions[shopId]) {
        // this.brandOptions[shopId].renderOptions = []
        return false;
      }
      const { refPid, catId } = this.brandOptions[shopId];
      getPddCategoryPropertiesNew({
        refPid, catId,
        value: queryText,
        pageSize: 50
      }, shopId).then((res) => {
        const { goodsTemplatePropValSearchResponse = {} } = res;
        const { list = [] } = goodsTemplatePropValSearchResponse;
        list.map(item => {
          item.vvalue = item.value;
          item.shopId = shopId;
          item.refPid = refPid;
          return item;
        })
        this.brandOptions[shopId].renderOptions = cloneDeep(list);
      })
    },
    async getPddBrandList(shopId) {
      let leafCategoryId = this.getCategoryId();
      if (!leafCategoryId || !shopId) return;
      this.$set(this.loading, shopId, true);
      this.getFail = {};
      try {
        const data = await getPddBrandList({ leafCategoryId, shopId, pageSize: 20 }) || [];
        this.loading[shopId] = false;
        let options = data.map(item => {
          return {
            shopId,
            vid: item.vid,
            vvalue: item.value,
            valueUnit: '',
            refPid: 310,
          };
        });
      
        this.$set(this.brandOptions, shopId, {
          refPid: 310,
          catId: leafCategoryId,
          renderOptions: cloneDeep(options),
          originOptions: cloneDeep(options)
        });
      } catch (error) {
        console.log(error, '-----error');
      }
    },
    getCategoryId() {
      let leafCategoryId = '';
      const categoryIds = this.categoryIds;
      if (categoryIds && categoryIds.length) {
        leafCategoryId = categoryIds[categoryIds.length - 1];
      }
      return leafCategoryId;
    },
    isBrand(attr) {
      // 是否是品牌
      return attr.refPid === 310 || attr.name === '品牌';
    },

    async useBrandConfInit() {
        const categoryId = this.getCategoryId();
        const categoryBrandRelations = await getApplyBrandConfig({ categoryId, baseItemId: this.baseItemId, shopType: PLATFORMID });
        let valueMap = {};
        let newVal = [];
        // 新增逻辑：检查是否有未匹配的 shopId
        const unmatchedShopIds = this.shopList
            .map(shop => shop.id)
            .filter(shopId => !categoryBrandRelations.some(item => item.shopId === shopId && item.relations.find(item=>item.categoryId == categoryId)));
        if (unmatchedShopIds.length > 0) {
            // 调用 getApplyToOtherShop 接口获取数据
            const res = await this.getApplyToOtherShop({
            shopType: PLATFORMID,
            shopIds: unmatchedShopIds.join(','),
            categoryId: (categoryId),
            });
            // 将返回的数据进行匹配
            unmatchedShopIds.forEach(shopId => {
            const shopData = res[shopId];
            if (shopData) {
                const newItem = {
                  vid: shopData.vid,
                  vvalue: shopData.vvalue,
                  categoryId: shopData.categoryId,
                  shopId: Number(shopId),
                  valueUnit: shopData.valueUnit || '',
                  refPid: shopData.refPid || '',
                };
                valueMap[shopId] = newItem;
                newVal.push(newItem);
            }
            });
        }
        this.shopList.forEach(shop => {
            const shopId = shop.id;
            let relations = (categoryBrandRelations.find(item => shopId === item.shopId) || {}).relations || [];
            let valueItem = relations.find(item => item.categoryId == categoryId);
            if (valueItem) {
            let newItem = {
              vid: valueItem.vid,
              vvalue: valueItem.vvalue,
              categoryId: valueItem.categoryId,
              shopId: Number(shopId),
              valueUnit: valueItem.valueUnit || '',
              refPid: valueItem.refPid || '',
            };
            valueMap[shopId] = newItem;
            newVal.push(newItem);
            }
        });
        Object.keys(valueMap).forEach(shopId => {
            if (!valueMap[shopId]) {
            valueMap[shopId] = valueMap[shopId];
            newVal.push(valueMap[shopId]);
            }
        })
        console.log(valueMap,newVal);
        this.$set(this, 'valueMap', valueMap);
        this.changeVal(newVal);
    },
    async useBrandConf() {
      const categoryId = this.getCategoryId();
      const valueMapShopIds = Object.keys(this.valueMap)
      const emptyShopIds = this.shopList.filter(item=>!valueMapShopIds.some(valueMapItem=>item.id == valueMapItem)).map(item=>item.id)
      // console.log(emptyShopIds,262);
      const brandParams = {
        categoryId, 
        baseItemId: this.baseItemId, 
        shopType: PLATFORMID,
      }
      const categoryBrandRelations = await getApplyBrandConfig(brandParams);
       // console.log(categoryBrandRelations,270);
     
      let valueMap = {};
      let newVal = [];
      this.shopList.forEach(shop => {
        const shopId = shop.id;
        let relations = (categoryBrandRelations.find(item => shopId == item.shopId) || {}).relations || [];
        let valueItem = relations.find(item => item.categoryId == categoryId);
        let isExistValueItem = Object.keys(this.valueMap)
        if (valueItem && !isExistValueItem.includes(String(shop.id))) {
          let newItem = {
            vid: valueItem.vid,
            vvalue: valueItem.vvalue,
            categoryId: valueItem.categoryId,
            shopId,
            valueUnit: valueItem.valueUnit || '',
            refPid: valueItem.refPid || '',
          };
          valueMap[shopId] = newItem;
          newVal.push(newItem);
        }
      });
        // 新增逻辑：检查是否有未匹配的 shopId
        let unmatchedShopIds = this.shopList
        .map(shop => shop.id)
        .filter(shopId => !categoryBrandRelations.some(item => item.shopId == shopId && item.relations.find(item=>item.categoryId == categoryId)));
        
      if (unmatchedShopIds.length > 0) {
        // 调用 getApplyToOtherShop 接口获取数据
        const res = await this.getApplyToOtherShop({
          shopType: PLATFORMID,
          shopIds: unmatchedShopIds.join(','),
          categoryId: categoryId,
        });
        // 将返回的数据进行匹配
        res &&  Object.keys(res).forEach(shopId => {
          const shopData = res[shopId];
          // if(Object.keys(this.valueMap).includes(shopId)) return
          if (shopData) {
            const newItem = {
              vid: shopData.vid,
              vvalue: shopData.vvalue,
              categoryId: Number(categoryId),
              shopId: shopId,
              valueUnit: shopData.valueUnit || '',
              refPid: shopData.refPid || '',
            };
            valueMap[shopId] = newItem;
            newVal.push(newItem);
          }
        });
      }
      const _valueMap = Object.assign({},this.valueMap,valueMap)
      this.$set(this, 'valueMap', _valueMap);
      this.value.map(item => {
        const index = newVal.findIndex(({ shopId }) => shopId == item.shopId);
        if (index == -1) {
          newVal.push(item)
        }
      })
      this.changeVal(newVal);
    },

    async getApplyToOtherShop(payload){
      const params = {
        ...payload,
      }
      const res =  await ApplyToOtherShop(params)
      return res
    },
    handleSetToShop(promiseConf,applyShopName){
      this.applyShopObj = promiseConf
      this.shopDialogVisible = true;
      this.applyShopName = applyShopName
    },
    confirmSelectShop(shops){
      this.shopDialogVisible = false
      this.$confirm(`选中店铺将匹配品牌【${this.applyShopName}】，匹配后将覆盖原品牌值，未匹配到将跳过，是否确认`, '提示', {
          confirmButtonText: '确定',
          type: 'warning'
      }).then(async() => {
        let leafCategoryId = this.getCategoryId();
        const shopIds = shops.map(item=>item.id)
        const params = {
            shopType:PLATFORMID,
            shopIds:shopIds.join(','),
            categoryId: leafCategoryId,
            brandName:this.applyShopName && this.applyShopName.includes('/')? this.applyShopName.split('/')[1]:this.applyShopName || ''
          }

          const res = await this.getApplyToOtherShop(params)
          const dataKeys = Object.keys(res)
          const dataKeysValue = Object.keys(this.valueMap)
          // for(const key in this.valueMap){
          //   if(dataKeys.includes((key))){
          //     const shopInfo = res[key];
          //     this.valueMap[key] = {...shopInfo,shopId: key}
          //   } 
          // }
          const newValue = []
          for(const key in res){
              const shopInfo = res[key];
              // this.valueMap[key] = { ...shopInfo,shopId: Number(key) }
              const item = { ...shopInfo, shopId: Number(key) }
              this.$set(this.valueMap, key, item);
              newValue.push(item) 
              // this.selectChange(this.valueMap[key]);
          }
          this.value.map(item => {
            const index = newValue.findIndex(({ shopId }) => shopId == item.shopId);
            if (index == -1) {
              newValue.push(item)
            }
          })
          console.log(newValue,this.value, 999);
          this.changeVal(newValue)
          this.$message.success('更新品牌成功！')
      }).catch(() => {
        // this.$message.error('更新品牌失败！')
      });

    },
  },
};
</script>

<style lang="scss" scoped>
.brandId-row {
  display: flex;
  align-items: center;
  ::v-deep .el-image{
    display: inline-block;
    vertical-align: middle;
  }
  .shop-title{
    display: inline-block;
    vertical-align: middle;
    .required{
      color: #F56C6C;
    }
  }
}
.error-text {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 10px;
}
.mt-15{
  margin-bottom: 15px;
}
</style>